import Paper from '@mui/material/Paper'
import * as React from 'react'
import Table from '@mui/material/Table'
import { styled } from '@mui/material/styles'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { getSelectedUnits } from '../SelectUnits/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { UseSetTotalEffect } from './hooks'
import { actions as registerActions } from '../Register/reducer'
import { ActionsDivComponent } from '../Register/Actions'
import { SelectUnit } from '../SelectUnits/types'

const PaperComponent = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey['900'],
}))

export const SummaryComponent: React.FC = () => {
  const dispatch = useDispatch()
  const selectedUnits = useSelector(getSelectedUnits) as SelectUnit[]
  UseSetTotalEffect()

  const onActiveStep = React.useCallback(
    (step: number) => {
      dispatch(registerActions.onActiveStep(step))
    },
    [dispatch]
  )

  let subTotal = 0
  selectedUnits.forEach((x) => {
    const total = Number(x.value) * x.price
    subTotal += +total
  })

  return (
    <PaperComponent variant="outlined">
      <Table size="small">
        <thead>
          <tr>
            <th style={{ width: 60, textAlign: 'left' }}>Size</th>
            <th style={{ width: 90, textAlign: 'left' }}>Climate</th>
            <th style={{ width: 90, textAlign: 'left' }}>Covered</th>
            <th style={{ width: 60, textAlign: 'left' }}>Qty</th>
            <th style={{ width: 60, textAlign: 'left' }}>Price</th>
            <th align="right">Monthly Total</th>
          </tr>
        </thead>
        <tbody>
          {selectedUnits.map((x) => {
            const total = Number(x.value) * x.price
            return (
              <tr key={x.id}>
                <td>{x.size}</td>
                <td>{x.isClimate ? 'Yes' : 'No'}</td>
                <td>{x.isCovered ? 'Yes' : 'No'}</td>
                <td>{x.value}</td>
                <td>{x.price}</td>
                <td style={{ textAlign: 'right' }}>
                  ${total.toLocaleString('en-US')}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <Table size="small">
        <tbody>
          <tr>
            <td
              style={{ textAlign: 'right', width: '100%', fontWeight: 'bold' }}
            >
              Total:
            </td>
            <td style={{ textAlign: 'left', fontWeight: 'bold' }}>
              ${subTotal.toLocaleString('en-US')}
            </td>
          </tr>
        </tbody>
      </Table>
      <ActionsDivComponent
        onActionLeft={() => onActiveStep(3)}
        leftIcon={<NavigateBeforeIcon />}
        textLeft="Previous"
        colorLeft="inherit"
        leftVariant="outlined"
        onActionRight={() => onActiveStep(5)}
        rightIcon={<NavigateNextIcon />}
        textRight="Next"
        colorRight="primary"
        rightVariant="contained"
      />
    </PaperComponent>
  )
}
